import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./hitachi-logo.png"
								alt="hitachi"
								className="work-image"
							/>
							<div className="work-title">Hitachi Digital Services</div>
							<div className="work-subtitle">
								Data Architect
							</div>
							<div className="work-duration">2021 - Present</div>
						</div>

						<div className="work">
							<img
								src="./iqvia.png"
								alt="iqvia"
								className="work-image"
							/>
							<div className="work-title">IQVIA</div>
							<div className="work-subtitle">
								Senior Software Developer
							</div>
							<div className="work-duration">2019 - 2021</div>
						</div>

						<div className="work">
							<img
								src="./deloitte.png"
								alt="deloitte"
								className="work-image"
							/>
							<div className="work-title">Deloitte</div>
							<div className="work-subtitle">
								Consultant
							</div>
							<div className="work-duration">2017 - 2019</div>
						</div>

						<div className="work">
							<img
								src="./lti.png"
								alt="LTI"
								className="work-image"
							/>
							<div className="work-title">LTI</div>
							<div className="work-subtitle">
								Software Engineer
							</div>
							<div className="work-duration">2013 - 2017</div>
						</div>
					</div>
					
				}
			/>
		</div>
	);
};

export default Works;
